import { VersionableId } from '../../../../types/versionableId';
import { useAppSelector } from '../../../../store/hooks';
import { selectSmscByVersionableId } from '../../../../store/smsc/smscSelector';
import SmscForm from '../../components/smsc/SmscForm';

type Props = {
  readonly smscId: VersionableId;
  readonly hideSmscForm: () => void;
};

const SmscViewFormContainer = (props: Props) => {
  const { smscId, hideSmscForm } = props;

  const smsc = useAppSelector(state => selectSmscByVersionableId(state, smscId));

  const initialValues = {
    ...smsc?.object,
  };

  return (
    <SmscForm
      title='View smsc'
      smscId={smscId}
      initialValues={initialValues}
      onCancel={hideSmscForm}
      readOnly={true}
    />
  );
};

export default SmscViewFormContainer;
